import { render, staticRenderFns } from "./GraphsDashboard.vue?vue&type=template&id=67244ae8&scoped=true"
import script from "./GraphsDashboard.vue?vue&type=script&lang=js"
export * from "./GraphsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67244ae8",
  null
  
)

export default component.exports